import React from 'react';

import NewPlatformInfoPage from '../components/NewPlatformInfoPage';

const NewPlatform = () => (
  <NewPlatformInfoPage
    lang="zh"
    title="Full Stack Open 正在迁移到新平台 | Full Stack open"
  />
);

export default NewPlatform;
